import React from "react";
// import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import client1 from "../Components/images/client1.jpeg";
import client2 from "../Components/images/client5.jpeg";
import client3 from "../Components/images/client3.jpeg";
import client4 from "../Components/images/client4.jpeg";
import client5 from "../Components/images/client2.jpeg";



// import Button from 'react-bootstrap/Button';
import logo from "../Components/images/logo.png";
import star from "../Components/images/star.png";
import car from "../Components/images/car.jpeg";
import magnet from "../Components/images/magnet.png";
import StrategicSessionBooking from "../Components/StrategicSessionBooking";
import ContactForm from "../Components/ContactForm";

export default function Contact() {
 

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-black text-white min-vh-100 "
    >

      <div
        className="d-flex flex-column mt-5"
        style={{ maxWidth: "1200px", width: "90%", margin: "0 auto" }}
      >
       

        <div className="home mt-5">
          <h1 className="display-3 fw-bold anton ft1 mt-5">
         Book your<span className="text-warning2"> FREE </span>
            
            <span className="text-warning2"> SESSION </span>
            
            today
          </h1>

          <p className="mt-4 text-secondary fs-5">
           Ready to scale your brand to new heights? Book your<br /> 
           FREE STRATEGIC SESSION today or send us a message <br />
           and tell us more about your business and questions. We<br />
            are more than happy to discuss them!
             
          </p>

         

           
        </div>


<div style={{marginBottom: "80px"}}>
         <StrategicSessionBooking/>
       </div>
    <div className="home">
    <h1 className="display-3 fw-bold anton ft1 mt-5">
        Or send us a <br /><span className="text-warning2"> MESSAGE. </span>
             
          </h1>

          <p className="mt-4 text-secondary fs-5">
           Send us an E-mail for all your inquires, questions, good <br /> 
          talk! We will get back to you within 24 hours.<br />
          </p>
</div>


<ContactForm/>
       
       





 
      </div>
    </motion.div>
  );
}
